import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useLanguage } from "@/contexts/LanguageContext";

const FAQ = () => {
  const { t } = useLanguage();

  return (
    <section id="faq" className="py-20">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16 scroll-reveal">
          <h2 className="text-4xl md:text-5xl font-black mb-6">
            {t('faq.title')}
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            {t('faq.subtitle')}
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="w-full space-y-4">
            {(() => {
              const questions = t('faq.questions');
              const questionsArray = Array.isArray(questions) ? questions : [];
              
              return questionsArray.map((faq: any, index: number) => (
                <AccordionItem 
                  key={index} 
                  value={`item-${index}`} 
                  className="card-premium scroll-reveal"
                  style={{ animationDelay: `${index * 50}ms` }}
                >
                  <AccordionTrigger className="text-left font-semibold hover:text-primary">
                    {faq?.question || `Question ${index + 1}`}
                  </AccordionTrigger>
                  <AccordionContent className="text-muted-foreground leading-relaxed">
                    {faq?.answer || 'Answer not available'}
                  </AccordionContent>
                </AccordionItem>
              ));
            })()}
          </Accordion>
        </div>

        <div className="text-center mt-12 scroll-reveal">
          <div className="card-premium inline-block p-6">
            <h3 className="font-bold mb-2">{t('faq.consultation')}</h3>
            <p className="text-muted-foreground text-sm mb-4">
              {t('faq.consultation')}
            </p>
            <button 
              className="hero-button"
              onClick={() => {
                document.getElementById('funnel')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              {t('application.urgency.freeConsultation')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;